import axios from 'axios';
import { Dispatch } from 'redux';

export const GET_CATEGORIES = "GET_CATEGORIES";
export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";

const API_URL = `${process.env.REACT_APP_API_URL}/categories`;

export const getCategories = () => async (dispatch: Dispatch) => {
    try {
        const response = await axios.get(`${API_URL}`);
        dispatch({
            type: GET_CATEGORIES,
            payload: response.data
        });
    } catch (error) {
        console.error("Kategoriler getirilirken hata oluştu:", error);
    }
};

export const createCategory = (categoryData: any) => async (dispatch: Dispatch) => {
    try {
        const response = await axios.post(`${API_URL}`, categoryData);
        dispatch({
            type: CREATE_CATEGORY,
            payload: response.data
        });
    } catch (error) {
        console.error("Kategori oluşturulurken hata oluştu:", error);
    }
};

export const updateCategory = (id: string, categoryData: any) => async (dispatch: Dispatch) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, categoryData);
        dispatch({
            type: UPDATE_CATEGORY,
            payload: response.data
        });
    } catch (error) {
        console.error("Kategori güncellenirken hata oluştu:", error);
        throw error;
    }
};

export const deleteCategory = (id: string) => async (dispatch: Dispatch) => {
    try {
        await axios.delete(`${API_URL}/${id}`);
        dispatch({
            type: DELETE_CATEGORY,
            payload: id
        });
    } catch (error) {
        console.error("Kategori silinirken hata oluştu:", error);
    }
}; 